var axios = require('axios')
const urlCustomer = process.env.version + '/product-customer'
const urlConvertKana = process.env.version + '/product-jp/nihongo/convert-kana'
const urlCheckAccountBySocial = process.env.version + '/product-customer/is-email-exist'
const urlLineAPI = 'https://api.line.me/oauth2/v2.1/token'

axios.register = function (data, success, callBackError) {
  this.post(urlCustomer + '/fe-registration', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getProfile = function (success, callBackError) {
  this.get(urlCustomer + '/customers-by-token')
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
      // if (typeof callBackError !== 'undefined') {
      //   callBackError(error.response.data)
      // }
      }
    })
}

axios.updateProfile = function (data, success, callBackError) {
  this.put(urlCustomer + '/customers', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.updatePassword = function (data, success, callBackError) {
  this.post(urlCustomer + '/update-password', data)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.createLocation = function (data, success, callBackError) {
  this.post(urlCustomer + '/locations', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.editLocation = function (data, success, callBackError) {
  this.put(urlCustomer + '/locations', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getLocation = function (data, success, callBackError) {
  this.get(urlCustomer + '/locations/' + data)
    .then(response => {
      success(response)
    }).catch(error => {
      console.log(error)
      if (error.response) { callBackError(error) }
    })
}

axios.deleteLocation = function (data, success, callBackError) {
  this.delete(urlCustomer + '/locations/' + data)
    .then(response => {
      success(response)
    }).catch(error => {
      console.log(error)
      if (error.response) { callBackError(error) }
    })
}
axios.registerConfirmation = function (data, success) {
  this.get(urlCustomer + '/confirm_email/' + data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response) { callBackError(error) }
    })
}

axios.lightRegisterConfirmation = function (data, success) {
  this.get(urlCustomer + '/confirm_light_email/' + data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response) { callBackError(error) }
    })
}

axios.checkExistEmail = function (data, success, callBackError) {
  this.post(urlCustomer + '/check_email', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.resetPassword = function (data, success, callBackError) {
  this.post(urlCustomer + '/reset_password', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.checkTokenResetPassowrd = function (data, success, callBackError) {
  this.post(urlCustomer + '/check_forgot_password_token', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}
axios.sendToFeedback = function (data, success, callBackError) {
  this.post(urlCustomer + '/contacts', data)
    .then(response => {
      success(response)
    }).catch(error => {
    if (error.response && error.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.convertKana = function (text, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false

  let api = urlConvertKana
  if(text){
    api += '?name=' + text

    this.get(api)
        .then(response => {
          success(response)
        }).catch(error => {
      if (error.response && error.response.status == 400) {
      }
    })
  }

}

axios.deleteCustomer = function (success, callBackError) {
  this.delete(urlCustomer + '/customer-delete-by-token/')
    .then(response => {
      success(response)
    }).catch(error => {
    console.log(error)
    if (error.response) { callBackError(error) }
  })
}

axios.getLineAccessToken = async function (data, success, callBackError) {
  try {
    const res = await this.post(urlLineAPI, data)
    success(res)
  } catch (err) {
    if (err.response && err.response.status == 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  }
}

axios.lightRegistration = function (data, success, callBackError) {
  this.post(urlCustomer + '/light-registration', data)
    .then(response => {
      success(response)
    })
    .catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.getDataSavedCard = async function (success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.get(urlCustomer + '/saved-cards').then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.removeSavedCard = function (uuid, success, callBackError) {
  this.delete(urlCustomer + `/saved-card/${uuid}`).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400) {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.setPreferredCreditCard = function (data, success, callBackError) {
  axios.options.flag = false
  axios.options.notify = false
  this.post(urlCustomer + '/payment-methods', data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status === 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

axios.checkAccountBySocial = function (data, success, callBackError) {
  this.post(urlCheckAccountBySocial, data)
    .then(response => {
      success(response)
    }).catch(error => {
      if (error.response && error.response.status == 400) {
        if (typeof callBackError !== 'undefined') {
          callBackError(error.response.data)
        }
      }
    })
}

export default axios



// WEBPACK FOOTER //
// ./src/api/Customer.js